import { render, staticRenderFns } from "./SubSampleDo.vue?vue&type=template&id=0508246c&scoped=true&"
import script from "./SubSampleDo.vue?vue&type=script&lang=js&"
export * from "./SubSampleDo.vue?vue&type=script&lang=js&"
import style0 from "./SubSampleDo.vue?vue&type=style&index=0&id=0508246c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508246c",
  null
  
)

export default component.exports